export default {
  currency: {
    malaysia: 'RM'
  },
  navbar: {
    logOut: 'Log Out',
    browse: 'Browse',
    promotions: 'Promotions',
    faq: 'FAQ',
    contactus: 'Contact Us',
    profile: 'Profile',
    orderhistory: 'Order History',
    cart: 'Cart',
    lastorder: 'View Your Last Order'
  },
  route: {
    browse: 'Browse',
    beer: 'Beer',
    cart: 'Cart',
    contact: 'Contact',
    faq: 'Faq',
    home: 'Home',
    orders: 'Orders',
    profile: 'Profile',
    promotions: 'Promotions'
  },
  browse: {
    browse: 'Browse',
    byBrewery: 'by Brewery',
    byStyle: 'by Style',
    byRegion: 'by Region'
  },
  form: {
    subject: 'Subject',
    message: 'Message'
  },
  pagetitle: {
    faq: 'Frequently Asked Questions',
    promotions: 'All Promotions',
    browse: 'Browse',
    contactus: 'Contact Us',
    cart: 'Cart',
    profile: 'Profile',
    history: 'Order History',
    orders: 'Orders',
    review: 'Review',
    successful: 'Order Success',
    overview: 'Order Overview'
  },
  title: {
    corebrands: 'Our Core Brands',
    promotions: 'Latest Promotions',
    contactus: 'Contact Us',
    cart: 'Your Order',
    customerdetails: 'Customer Details',
    delivery: 'Delivery Address',
    address: 'Address',
    products: 'Products',
    purchaseorder: 'Purchase Order',
    gst: 'GST',
    subtotal: 'Sub-Total',
    total: 'Total',
    creditterms: 'Credit Terms',
    browse: 'An Extensive Selection of Imported Craft Beer',
    outlets: 'Outlets'
  },
  subtitle: {
    corebrands: 'Some write up here to explain what core brands are?',
    ordersuccessful: 'Order Successfully Placed',
    yourpurchaseorder: 'Your Purchase Order Number is: ',
    ordersuccessfulemail: 'You will receive an order confirmation email with details of your order shortly.',
    contactmessage: 'Need some beer help? You may contact us via the form below and we will reply as soon as we can. If you need a faster resolution, please contact your beer salesperson between 10.00am to 6.00pm.',
    thankyou: 'Thank you!',
    disclaimer: '[DISCLAIMER: If details above are inaccurate, please contact your sales representative]',
    browse: 'We offer many different craft beers from 28 different breweries around the world. Browse using our detailed filters to find your craft beer.',
    orderquantity: 'Order quantity is in multiples of the MOQ for this product.',
    invoicenote: 'Invoice price may vary slightly due to rounding.'
  },
  profile: {
    customername: 'Customer Name',
    email: 'Email',
    contactperson: 'Contact Person',
    contactnumber: 'Contact Number',
    address1: 'Address 1',
    address2: 'Address 2'
  },
  login: {
    title: 'AUTHORIZED ACCESS ONLY',
    logIn: 'LOGIN',
    email: 'Email',
    help: 'Help - Trouble logging in',
    username: 'Username',
    password: 'Password',
    any: 'any',
    thirdparty: 'Or connect with',
    thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !'
  },
  button: {
    proceed: 'Proceed',
    all: 'All',
    core: 'Core',
    keg: 'Keg',
    bottle: 'Bottle',
    promo: 'Promo',
    brewery: 'Brewery',
    style: 'Style',
    region: 'Region',
    viewall: 'View All',
    addtocart: 'Add To Cart',
    addsample: 'Add Sample',
    remove: 'Remove',
    submitorder: 'Submit Order',
    confirm: 'Confirm',
    back: 'Back',
    home: 'Home',
    view: 'View',
    reorder: 'Re-Order',
    loadmore: 'Load More',
    viewcart: 'View Cart',
    sendto: 'Send to:',
    primary: 'Primary',
    download: 'Download'
  },
  dialogTitle: {
    brewery: 'Brewery',
    style: 'Style',
    region: 'Region'
  },
  error: {
    noresults: 'Beer Sold Out',
    nopromotions: 'There aren\'t any further promotions available at this time.',
    somethingwrong: 'Something went wrong, please refresh the page to proceed. If the issue still persist, please contact our customer service. Thank you!'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js